import React from 'react';

import { EditableSession, EventType } from 'types/event.types';
import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';

import { GuestCheckInBanner } from './GuestCheckInBanner';

interface GuestCheckInBannersProps {
  eventSessions?: EditableSession[];
}

const GuestCheckInBanners: React.FC<GuestCheckInBannersProps> = ({ eventSessions }) => {
  /**
   * Note: For check-in banners only, we check the `hasEnded` flag to avoid showing too many banners for past event sessions.
   * (e.g. event with 15 past sessions)
   */

  const event = useEditableEvent();

  // Single event
  if (event.eventType === EventType.SINGLE && event.isGuestCheckinOpen && !event.hasEnded) {
    return <GuestCheckInBanner />;
  }

  // Multi-session event
  const sessionsWithCheckInOpen = eventSessions?.filter(
    (session) => session.isGuestCheckinOpen && !session.hasEnded
  );

  if (!sessionsWithCheckInOpen?.length) {
    return null;
  }

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      {sessionsWithCheckInOpen?.map((session) => (
        <GuestCheckInBanner key={session.id} session={session} />
      ))}
    </div>
  );
};

export { GuestCheckInBanners };
